import { createWebHistory, createRouter } from 'vue-router';

// import Test from '@/views/Test.vue';

//@ts-expect-error wip
import Auth from './modules/auth';
import Payments from './modules/payments';
//@ts-expect-error wip
import Reports from './modules/reports';
//@ts-expect-error wip
import Tools from './modules/tools';
import Settings from './modules/settings';
//@ts-expect-error wip
import Affiliates from './modules/affiliates';
//@ts-expect-error wip
import Players from './modules/players';
import Service from './modules/service';
//@ts-expect-error wip
import Teams from './modules/teams';
import MediaBuying from './modules/mediaBuying';
import Dashboard from './modules/dashboard';
//@ts-expect-error wip
import CRM from './modules/crm';

const RouterInstance = createRouter({
  routes: [
    // {
    //   path: '/test',
    //   component: Test,
    // },
    ...Auth,
    ...Affiliates,
    ...Payments,
    ...Players,
    ...Reports,
    ...Tools,
    ...Settings,
    ...Teams,
    ...MediaBuying,
    ...Dashboard,
    ...CRM,
    ...Service,
  ],
  history: createWebHistory(),
});

export default RouterInstance;
